import {SET_SLIDE_LOADING, SET_SLIDE_NOT_LOADING} from "../redux_constants/slideLoading.constant";

export const setSlideToLoading = (slideId) => ({
    type: SET_SLIDE_LOADING,
    slideId: slideId
});

export const setSlideToNotLoading = () => ({
    type: SET_SLIDE_NOT_LOADING
});
